export default __webpack_public_path__ + "static/media/sitanshu.d11eea2e.png";